import type { ReactNode } from 'react';

export const symbol_attribution: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-617q-51 0-77 11.5T377-570v168q0 6 4.5 10.5T392-387h44v136q0 18 13 31t31 13q18 0 31-13t13-31v-136h44q6 0 10.5-4.5T583-402v-168q0-24-26-35.5T480-617ZM323-111q-73-31-127-85t-85-127q-31-73-31-157t31-157q31-73 85-127t127-85q73-31 157-31t157 31q73 31 127 85t85 127q31 73 31 157t-31 157q-31 73-85 127t-127 85q-73 31-157 31t-157-31Zm399.5-126.5Q820-335 820-480t-97.5-242.5Q625-820 480-820t-242.5 97.5Q140-625 140-480t97.5 242.5Q335-140 480-140t242.5-97.5Zm-204-424Q534-677 534-700t-15.5-38.5Q503-754 480-754t-38.5 15.5Q426-723 426-700t15.5 38.5Q457-646 480-646t38.5-15.5ZM480-480Z"
		/>
	</svg>
);
